import React, { useEffect, useState } from "react";
import styles from "./reservationclean.module.css";
import { getFetch, postFetch } from "../../fetch/fetch";
import { CircularProgress } from "@mui/material";
import { Button } from "@mui/joy";
import ImageViewer from "../etc/imageviewer/imageviewer";
import { IonApp } from "@ionic/react";
import ImageWithLoader from "../../dashboard/components/controls/etc/imagewithloader";

const CleanReport: React.FC<any> = (props) => {

    const [notes, setNotes] = useState<any>(null);
    const [selectedReference, setSelectedReference] = useState<any>(null);
    const [selectedNotes, setSelectedNotes] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [mediaUrls, setMediaUrls] = useState<Record<string, string | null>>({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [src, setSrc] = useState("");

    //현장 비밀번호 관련 state
    const [itemId, setItemId] = useState<string>("");
    const [needPassword, setNeedPassword] = useState(false);
    const [passwordInput, setPasswordInput] = useState("");
    const [passwordError, setPasswordError] = useState(false);
    const [mediaKey, setMediaKey] = useState("");

    const handleClose = () => {
        setIsModalOpen(false);
    };

    async function getMediaUrl(mediaId: string, token: string, media_type: string) {
        try {

            const result: any = await postFetch("/dashboard/safetyculture/getmediaurl", {
                mediaId,
                token,
                media_type
            });


            return result.url;

        } catch (error) {
            console.error(error);
            return null;
        }
    }

    useEffect(() => {
        // selectedReference가 변경될 때마다 전체 미디어의 URL을 한 번에 로드
        const fetchAllMediaUrls = async () => {

            console.log(selectedReference);

            if(!selectedReference || !selectedReference.inspection_context || !selectedReference.inspection_context.inspection_item_attachments) return;

            const { media } = selectedReference.inspection_context.inspection_item_attachments;

            console.log(media);

            // Promise.all을 이용하여 병렬로 fetch 요청
            const promises = media.map(async (item: any) => {
                const url = await getMediaUrl(item.id, item.token, item.media_type);
                return { media_id: item.id, url };
            });

            const results = await Promise.all(promises);

            // 결과를 객체 형태로 재구성
            const newMediaUrls: Record<string, string | null> = {};
            results.forEach(({ media_id, url }) => {
                newMediaUrls[media_id] = url;
            });

            console.log(newMediaUrls);

            setMediaUrls(newMediaUrls);
        };

        if (selectedReference) {
            //fetchAllMediaUrls();
        }

    }, [selectedReference]);

    //url 로부터 query string 가져오기
    useEffect(() => {
        // 해시 예: "#/mobiledashboard/cleanreport?itemId=123"
        const hash = window.location.hash;

        // 쿼리 문자열만 추출 ("?itemId=123")
        const [_, queryString = ""] = hash.split("?");

        // "itemId=123" 형태일 때만 파라미터 파싱
        const urlParams = new URLSearchParams(queryString);
        const itemId = urlParams.get("itemId");

        console.log(itemId); // "123" (또는 null)

        if (itemId) {
            setItemId(itemId);
            //이전에 맞게 입력했던 비밀번호가 있으면 처음부터 붙여서 요청
            const savedPw = localStorage.getItem("cleanReportPw");
            getInformation(itemId, savedPw ? savedPw : undefined, true);
        } else {
            console.log("itemId is null");
        }

    }, []);

    const getInformation = async (itemId: string, pw?: string, isFromSaved?: boolean) => {

        try {

            setLoading(true);

            var fetchUrl = "/dashboard/todoist/getcleanreport?itemId=" + itemId;

            if (pw) {
                fetchUrl += "&pw=" + pw;
            }

            const result: any = await getFetch(fetchUrl);

            console.log(result);

            //인증 실패(NOT_LOGIN, Not_VALUE, not now 등) 시 비밀번호 입력 화면 표시
            if (result.message !== "success" || !result.data) {
                setLoading(false);
                if (pw) {
                    //틀린 비밀번호는 저장소에서 제거
                    localStorage.removeItem("cleanReportPw");
                    if (!isFromSaved) {
                        //직접 입력한 경우에만 에러 메시지 표시
                        setPasswordError(true);
                    }
                }
                setNeedPassword(true);
                return;
            }

            //비밀번호로 열람 성공 시 저장해서 다음부터 안 물어봄
            if (pw) {
                localStorage.setItem("cleanReportPw", pw);
            }
            setNeedPassword(false);
            setPasswordError(false);

            //사진 스트림 URL에 붙일 키 (네이티브 앱 <img>는 인증 헤더를 못 붙임)
            if (result.mediaKey) {
                setMediaKey(result.mediaKey);
            }

            const data = result.data;

            console.log(data);

            const { notes, reference } = data;

            setNotes(notes);

            if (reference) {
                setSelectedReference(reference[0].reference[0]);
            }
            setLoading(false);

        } catch (e) {
            console.log(e);
            setLoading(false);
        }

    }

    const handlePasswordSubmit = () => {
        if (!passwordInput || !itemId) {
            return;
        }
        getInformation(itemId, passwordInput);
    }


    useEffect(() => {

        if (!notes) return;

        const newSelectedNotes: any = [];

        console.log(notes);

        notes.forEach((eachData: any) => {

            const data = eachData.data;

            if (data.content) {

                const oneRow: any = {
                    ...data,
                    kind: "text",
                    content: convertLinks(data.content)
                }

                newSelectedNotes.push(oneRow);

            }

            if (data.file_attachment && data.file_attachment.image) {

                const oneRow: any = {
                    ...data,
                    kind: "img",
                    content: data.file_attachment.image
                }

                newSelectedNotes.push(oneRow);

            }

            //영상 댓글 (file_type이 video로 시작, image 필드 없음)
            if (data.file_attachment && !data.file_attachment.image && data.file_attachment.file_url && String(data.file_attachment.file_type || "").startsWith("video")) {

                const oneRow: any = {
                    ...data,
                    kind: "video",
                    content: data.file_attachment.file_url
                }

                newSelectedNotes.push(oneRow);

            }

        })

        console.log(newSelectedNotes);

        setSelectedNotes([...newSelectedNotes]);

    }, [notes]);

    function convertLinks(text: string) {
        var urlRegex = /(https?:\/\/\S+)/g;
        return text.replace(urlRegex, function (url: string) {
            // 마지막 문자가 알파벳이나 숫자가 아닌 경우, URL에서 제외합니다.
            var lastIndex = url.length - 1;
            var punctuation = url[lastIndex];
            if (!(/[a-zA-Z0-9]/.test(punctuation))) {
                url = url.substring(0, lastIndex);
            }
            return '<a target="_blank" href="' + url + '">' + url + '</a>';
        });
    }


    //인증 안 된 사용자(비로그인, student/parent 계정 등)에게 비밀번호 입력 화면 표시
    if (needPassword) {
        return (
            <div>
                <div className={styles.mainDiv} style={{ maxWidth: "650px" }}>
                    <div className={styles.title} style={{ marginTop: "48px" }}>
                        청소 리포트
                    </div>
                    <div style={{ fontFamily: "Apple_R", fontSize: "16px", color: "#555E68", textAlign: "center" }}>
                        비밀번호를 입력하면 리포트를 볼 수 있어요
                    </div>
                    <input
                        type="text"
                        inputMode="numeric"
                        placeholder="비밀번호"
                        value={passwordInput}
                        onChange={(e) => { setPasswordInput(e.target.value); setPasswordError(false); }}
                        onKeyDown={(e) => { if (e.key === "Enter") { handlePasswordSubmit(); } }}
                        style={{
                            display: "block", width: "100%", boxSizing: "border-box",
                            marginTop: "24px", padding: "14px", fontSize: "18px", fontFamily: "Apple_R",
                            border: "1px solid #ccc", borderRadius: "8px", textAlign: "center", outline: "none"
                        }}
                    />
                    {
                        passwordError &&
                        <div style={{ fontFamily: "Apple_R", fontSize: "14px", color: "#d32f2f", marginTop: "12px", textAlign: "center" }}>
                            비밀번호가 올바르지 않습니다
                        </div>
                    }
                    <Button
                        fullWidth
                        variant="solid"
                        color="primary"
                        loading={loading}
                        disabled={!passwordInput || loading}
                        onClick={handlePasswordSubmit}
                        sx={{ marginTop: "16px" }}
                    >
                        확인
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <div>
                <div className={styles.mainDiv} style={{
                    maxWidth : "650px"
                }}>
                    <div className={styles.title}>
                        문제 상황
                    </div>
                    {
                        selectedReference
                            ?
                            <div style={{
                                width: "100%",
                                maxHeight: "60vh",
                                overflowY: "auto",
                                padding: "12px"
                            }}
                                className={styles.modalPage}
                            >
                                <div style={{
                                    fontFamily: "Apple_SB",
                                    fontSize: "18px",
                                    marginTop: "12px"
                                }}>
                                    {
                                        selectedReference.inspection_context.inspection_item_path.map((path: string, index: number) => {
                                            if (index === selectedReference.inspection_context.inspection_item_path.length - 1) {
                                                return (
                                                    <span key={index}>
                                                        {path}
                                                    </span>
                                                )
                                            } else {
                                                return (
                                                    <span key={index}>
                                                        {path} {" > "}
                                                    </span>
                                                )
                                            }
                                        })
                                    }
                                </div>
                                <div style={{
                                    fontFamily: "Apple_SB",
                                    fontSize: "18px",
                                    marginTop: "12px"
                                }}>

                                    {selectedReference?.inspection_context?.inspection_item_name}
                                </div>
                                {
                                    selectedReference?.inspection_context?.inspection_item_attachments?.note
                                        ?
                                        <div style={{
                                            fontFamily: "Apple_R",
                                            fontSize: "16px",
                                            marginTop: "16px",
                                            color: " #555E68",
                                            marginBottom: "16px"
                                        }}>
                                            {selectedReference.inspection_context.inspection_item_attachments.note}
                                        </div>
                                        :
                                        ""
                                }

                                {selectedReference?.inspection_context?.inspection_item_attachments?.media.length > 0 && (
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr", // 2열 격자
                                            gap: "12px", // 카드(칸) 사이 간격,
                                            marginTop: "24px"
                                        }}
                                    >
                                        {selectedReference.inspection_context.inspection_item_attachments.media.map(
                                            (media: any, index: number) => {

                                                const media_type = media.media_type;
                                                const media_id = media.id;
                                                const token = media.token;

                                                const inspection_id = selectedReference.inspection_context.inspection_id;

                                                //mediaKey는 사진 스트림 인증용 (<img>는 인증 헤더·쿠키를 못 쓰는 환경 대응)
                                                const url = `https://peetsunbae.com/dashboard/safetyculture/getmediaurlstream/${inspection_id}/${media_id}${mediaKey ? "?pw=" + mediaKey : ""}`;
                                                // const url = mediaUrls[media_id];

                                                console.log(url);

                                                if (!url) {
                                                    return (
                                                        <div key={index} style={{
                                                            width: "100%",
                                                            height: "120px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}>
                                                            <CircularProgress
                                                                size='sm'
                                                            />
                                                        </div>
                                                    );
                                                }

                                                if (media_type === "MEDIA_TYPE_IMAGE") {
                                                    // 이미지
                                                    return (
                                                        // <img
                                                        //     key={index}
                                                        //     src={url}
                                                        //     alt="media"
                                                        //     style={{
                                                        //         width: "100%",
                                                        //         height: "auto",
                                                        //         borderRadius: "8px",
                                                        //         cursor: "pointer",
                                                        //     }}
                                                        // />
                                                        <div onClick={() => {
                                                        }}>
                                                            <ImageWithLoader
                                                                src={url}
                                                                onClick={() => { }}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "auto",
                                                                    borderRadius: "8px",
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        </div>
                                                    );
                                                } else if (media_type === "MEDIA_TYPE_VIDEO") {
                                                    // 동영상
                                                    return (
                                                        <a href={url} rel="noopener noreferrer" key={index}>
                                                            비디오 다운로드
                                                        </a>
                                                    );
                                                }
                                                return null;
                                            }
                                        )}
                                    </div>
                                )}
                            </div>
                            :
                            ""
                    }

                    <div className={styles.title} style={{
                        marginTop: "48px"
                    }}>
                        해결 상황
                    </div>
                    {
                        selectedNotes && selectedNotes.map((eachData: any, index: number) => {

                            if (!eachData) {
                                return;
                            }

                            if (eachData.kind === "text") {
                                return (
                                    <div key={index} style={{
                                        fontFamily: "Apple_R",
                                        fontSize: "16px",
                                        marginTop: "16px",
                                        color: " #555E68",
                                        marginBottom: "16px"
                                    }} dangerouslySetInnerHTML={{ __html: eachData.content }}></div>
                                )
                            } else if (eachData.kind === "img") {
                                return (
                                    <img
                                        key={index}
                                        src={eachData.content}
                                        alt="media"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            marginTop: "12px"
                                        }}

                                    />
                                )
                            } else if (eachData.kind === "video") {
                                return (
                                    <video
                                        key={index}
                                        src={eachData.content}
                                        controls
                                        playsInline
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "8px",
                                            marginTop: "12px"
                                        }}
                                    />
                                )
                            }
                            return null;

                        })
                    }
                </div>
        </div>
    )
}

export default CleanReport;